<template>
  <div v-if="noticeList && noticeList.length"
       class="notice-list">
      <ul class="list">
        <li class="notice" v-for="(notice,index) in noticeList"
            @click="noticeDetail(notice.id)"
            :key="index">
          <span class="notice-title">{{ notice.title }}</span>
          <span class="time">{{ notice.add_time }}</span>
        </li>
      </ul>
      <div class="page">
        <el-pagination
            background
            :page-size="params.page_size"
            layout="prev, pager, next"
            @current-change="handleCurrentChange"
            :total="noticeTotal">
        </el-pagination>
      </div>
  </div>
  <el-empty v-else description="暂无公告"/>
</template>

<script>
  import apis from "@/api/apis";

  export default {
    name: 'noticeList',
    data() {
      return {
        params: {
          cate_id: '',// 公告分类id
          page: 1,// 第几页
          page_size: 10,
        },
        noticeCateId: '',
        noticeTotal: 0,
        noticeList: [], // 分类下的notice
      }
    },
    mounted() {
      this.init()
    },
    methods: {
      init() {
        const noticeCateId = this.$route.params.noticeCateId
        if (!noticeCateId) {
          return
        }
        this.noticeCateId = noticeCateId
        this.params = {
          cate_id: noticeCateId,// 公告分类id
          page: 1,// 第几页
          page_size: 10,
        }
        this.getNoticeList()
      },
      getNoticeList() {
        apis.notice.noticeList(this.params).then(res => {
          // console.log(res)
          this.noticeList = res.data.list
          this.noticeTotal = res.data.count
        })
      },
      handleCurrentChange(current) {
        this.params.page = current
        this.getNoticeList()
      },
      noticeDetail(id) {
        this.$router.push({path: `/notice/${this.noticeCateId}/detail/${id}`})
      },
    },
    watch:{
      '$route.params.noticeCateId'(){
        this.init()
      }
    }
  }
</script>
<style scoped lang="scss">
  .notice-list{
    min-height: 100%;
    padding-bottom: 76px;
    position: relative;
    .list{
      .notice{
        padding: 20px 0;
        border-bottom: 1px solid rgba(0, 0, 0, 0.1);
        cursor: pointer;
        display: flex;
        justify-content: space-between;
        align-items: center;
        &:hover{
          color: #0B4FFC;
        }
        .notice-title{
          width: 752px;
          margin-right: 40px;
          font-size: 16px;
          font-weight: bold;
          color: rgba(0, 0, 0, 0.85);

        }
        .time{
          font-size: 14px;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.65);
          line-height: 20px;
          display: inline-block;
          width: 150px;
          flex: none;
        }
      }
    }
    .page{
      padding: 20px 5px;
      text-align: right;
      width: 100%;
      position: absolute;
      bottom: 0;
    }
  }

</style>
